import { createReducer, on } from '@ngrx/store';
import * as PlantListCompanyActions from './plant-list-company.actions';
import { PlantListCompanyState } from './plant-list-company.models';

export const initialState: PlantListCompanyState = {
  plants: {},
  loading: undefined,
  error: null,
  currentKey: null,
};

export const plantListCompanyReducer = createReducer(
  initialState,
  on(PlantListCompanyActions.loadPlantListCompany, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlantListCompanyActions.loadPlantListCompanySuccess, (state, { key, plants }) => ({
    ...state,
    loading: false,
    error: null,
    plants: { [key]: plants },
    currentKey: key,
  })),
  on(PlantListCompanyActions.loadPlantListCompanyFailure, (state, { error, key }) => ({
    ...state,
    loading: false,
    error,
    plants: { [key]: [] },
  })),
  on(PlantListCompanyActions.resetPlantListCompany, () => initialState),
);
